import type { FetchBaseQueryError } from "@reduxjs/toolkit/query/react";
import axios from "axios";
import { api } from "@/api/apiSlice";
import { backendBase } from "@/api/backendBase";
import type { Cin7ListResponse, Cin7Customer } from "@/api/dtos";
import type { Customer } from "./_models/Customer";
import { toCustomerFromCin7Customer } from "./_transformers/toCustomerFromCin7Customer";

type CustomerListResponse = Cin7ListResponse<"CustomerList", Cin7Customer>;

const PAGE_LIMIT = 500;

/** Cin7 customers, first page of up to 500 (GET /cin7/customer-list via the backend Cin7 proxy). */
export const getCustomerListApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getCustomerList: builder.query<Customer[], void>({
      queryFn: async () => {
        try {
          const res = await axios.get<CustomerListResponse>(
            `${backendBase()}/cin7/customer-list`,
            {
              params: { Page: 1, Limit: PAGE_LIMIT },
              headers: { Accept: "application/json" },
            },
          );
          const customers = res.data.CustomerList.map((x) => toCustomerFromCin7Customer(x));
          return { data: customers };
        }
        catch (e) {
          if (axios.isAxiosError(e) && e.response) {
            return {
              error: { status: e.response.status, data: e.response.data } as FetchBaseQueryError,
            };
          }
          return {
            error: { status: "FETCH_ERROR", error: String(e) } as FetchBaseQueryError,
          };
        }
      },
    }),
  }),
});

export const getCustomerList = getCustomerListApi.endpoints.getCustomerList;
